import { Dispatch, SetStateAction } from "react";
import { FlexCol, FlexRowCenter } from "src/utils/flexLayouts";
import { Link } from "react-router-dom";
import { ReportIcon } from "src/components/ui-icons/card";
import { ArrowIcon, ChevronIcon, DisplayIcon } from "src/pages/Reports/shared/icons";
import FavoriteButton from "src/pages/DashboardPage/acadia/components/FavoriteButton";
import { favoriteFiltersListName } from "src/api/config";
import { useAppSelector } from "src/hooks/redux";
import {
  selectAddStatus,
  selectDeleteStatus,
  selectGetStatus,
  selectItems,
  selectUpdateStatus,
} from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";

type Props = {
  openFiltersModal: () => void;
  onDeleteFilter: () => void;
  setBundlesModalOpened: Dispatch<SetStateAction<boolean>>;
  isFavorite: boolean;
  noFiltersSelected: boolean;
};

function Breadcrumbs({
  openFiltersModal,
  onDeleteFilter,
  setBundlesModalOpened,
  isFavorite,
  noFiltersSelected,
}: Props) {
  const favoriteFiltersResponseData = useAppSelector((state) => selectItems(state, favoriteFiltersListName));
  const favoriteFiltersStatus = useAppSelector((state) => selectGetStatus(state, favoriteFiltersListName));
  const favoriteFiltersUpdatedStatus = useAppSelector((state) => selectUpdateStatus(state, favoriteFiltersListName));
  const favoriteFiltersDeletedStatus = useAppSelector((state) => selectDeleteStatus(state, favoriteFiltersListName));
  const favoriteFiltersAddedStatus = useAppSelector((state) => selectAddStatus(state, favoriteFiltersListName));

  const handleToggleFavorite = () => {
    if (isFavorite) {
      // Удаляем текущий фильтр из избранного
      onDeleteFilter();
    } else {
      // Открываем модалку для сохранения
      openFiltersModal();
    }
    // Закрываем модалку со списком избранных фильтров
    setBundlesModalOpened(false);
  };

  const loadingStatus =
    favoriteFiltersUpdatedStatus === "LOADING" ||
    favoriteFiltersDeletedStatus === "LOADING" ||
    favoriteFiltersAddedStatus === "LOADING" ||
    favoriteFiltersStatus === "LOADING";

  return (
    <FlexCol className="w-full">
      <nav className="flex gap-5 justify-between w-full" aria-label="Breadcrumb">
        <ul className="inline-flex gap-2 items-center">
          <li className="inline-flex items-center" aria-current="page">
            <Link
              to="/dashboard/1/reports"
              className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer"
            >
              <ReportIcon className="w-5 h-5" />
              <span>Отчеты</span>
            </Link>
          </li>
          <li className="inline-flex items-center" aria-current="page">
            <ArrowIcon />
          </li>
          <li
            className="inline-flex items-center min-w-[190px] space-x-2 text-base font-medium cursor-pointer"
            aria-current="page"
          >
            <DisplayIcon className="w-5 h-5" />
            <span>Отчет ознакомлений по рабочим местам</span>
          </li>
        </ul>
        <FlexRowCenter className="gap-[10px] relative">
          <FavoriteButton
            isFavorite={{ state: isFavorite, id: null }}
            onToggle={handleToggleFavorite}
            disabled={noFiltersSelected || loadingStatus}
          />

          {loadingStatus ? (
            <Loading />
          ) : favoriteFiltersResponseData.length > 0 ? (
            <button onClick={() => setBundlesModalOpened((prev) => !prev)}>
              <ChevronIcon className="w-5 h-3 duration-300 rotate-180 text-dark6 hover:text-darkblue" />
            </button>
          ) : null}
          {/* <BundlesModal opened={bundlesModalOpened} /> */}
        </FlexRowCenter>
      </nav>
    </FlexCol>
  );
}

export default Breadcrumbs;
